module.exports = __webpack_public_path__ + "static/img/column_img_4-2.5f73731b.png";